import React from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Color } from "../../../../../../../components/Form/Button";
import { GroupedButtons } from "../../../../../../../components/Generic/GroupedButtons";
import { useAppState } from "../../../../../../../context/StateContext";
import useStyles from "./styles";

interface DespatchActionsButtonsProps {
  leftPanelSelected: string;
  validateAndSaveDespatch: () => void;
  onCancel: () => void;
  loading: boolean;
  viewOnly: boolean;
  isWarehouseUser: boolean;
  despatchAlreadySubmitted: boolean;
  despatchId?: number;
}

const DespatchActionsButtons = (props: DespatchActionsButtonsProps) => {
  const {
    validateAndSaveDespatch,
    onCancel,
    loading,
    viewOnly,
    isWarehouseUser,
    despatchId,
    despatchAlreadySubmitted,
  } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { isFMVersion } = useAppState();

  const save = () => {
    if (!isWarehouseUser) {
      return () => validateAndSaveDespatch();
    }

    return undefined;
  };

  return (
    <Box
      className={classes.buttons}
      display="flex"
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent={"flex-end"}
        className={classes.buttons}
      >
        <GroupedButtons
          buttons={[
            {
              name: "cancel",
              action: onCancel,
              disabled: loading,
              variant: "text",
              customColor: Color.CANCEL,
              text: translate("cancel"),
            },
            {
              name: "save",
              action: save(),
              disabled: viewOnly || (despatchAlreadySubmitted && !isFMVersion),
              loading,
              className: isFMVersion ? undefined : classes.saveAndBook,
              customColor: Color.SUCCESS,
              text: !despatchId ? translate("create") : translate("save"),
            },
          ]}
        ></GroupedButtons>
      </Box>
    </Box>
  );
};

export default DespatchActionsButtons;
